<template>
	<div class="container">

		<el-scrollbar id="menuWarpper" style="height:calc(99%);background-color: #FFFFFF;margin-top: 0px;">
			<div class="main">
				<el-button class="fanhuiBtn" @click="fanhui()">返回</el-button>
				<div class="yonghuminglabe">修改账号信息</div>
				<div class="header-con">
					<div class="maina">
						<el-form :model="form" :rules="formRule" ref="form" label-width="140px" label-position="right"
							style="display: inline">
							<el-row>
								<el-col :span="12">
									<el-form-item style="width:100%" label="账号：">
										<el-input style="width:100%" type="text" :disabled="true"
											v-model="form.kefuzhanghao" ref="kefuzhanghao"
											@keyup.enter.native="xzkefumima" placeholder="请设置您的登录账号">
										</el-input>

									</el-form-item>
								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="密码：">
										<el-input style="width:100%" type="text" v-model="form.kefumima" ref="kefumima"
											@keyup.enter.native="xzkefudianhua" placeholder="请设置您的登录密码">
										</el-input>
									</el-form-item>

								</el-col>

								<el-col :span="12">

									<el-form-item style="width:100%" label="姓名：" prop="kefuxingming">
										<el-input style="width:100%" type="text" v-model="form.kefuxingming"
											ref="kefuxingming" @keyup.enter.native="xzkefudianhua"
											placeholder="请输入您的姓名">
										</el-input>
									</el-form-item>

								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="电话：" prop="kefudianhua">
										<el-input style="width:100%" type="text" v-model="form.kefudianhua"
											ref="kefudianhua" @keyup.enter.native="xzchanpinxian"
											placeholder="请输入您的联系方式">
										</el-input>
									</el-form-item>

								</el-col>

								<el-col :span="12">

									<el-form-item style="width:100%" label="产品线：" prop="person">

										<el-scrollbar
											style="height:350px;background-color: #FFFFFF;border: 1px solid #d9d9d9;border-radius: 6px;padding-left: 10px">

											<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
												@change="handleCheckAllChange">全选</el-checkbox>

											<el-checkbox-group v-model="checkedCities"
												@change="handleCheckedCitiesChange">
												<el-checkbox style="width: 80%;" v-for="item in staff"
													:label="item.Code" :key="item.Code">
													{{item.Name}}
												</el-checkbox>
											</el-checkbox-group>
										</el-scrollbar>
									</el-form-item>


								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="角色：" prop="juese">

										<el-select style="width:100%" v-model="form.juese" filterable ref="juese"
											placeholder="输入关键词搜索" :filter-method="bindSelectChangejs"
											@change="dianjichanpinxianjs">
											<el-option v-for="item in jueseList" :key="item.Code" :label="item.Name"
												:value="item.Code">
											</el-option>
										</el-select>

									</el-form-item>
								</el-col>







								<el-col :span="24">

									<el-button class="tijiaobtn" type="primary" @click="submitForm()" :disabled="isTiJiao">提交
									</el-button>
								</el-col>

							</el-row>

						</el-form>

					</div>


				</div>
			</div>
		</el-scrollbar>

	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	export default {
		name: "xiugaizhanghaoxinxi",
		data() {
			return {
				isTiJiao:false,
				checkAll: false,
				checkedCities: this.$route.query.chanpinxian.map(Number),
				isIndeterminate: true,
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				yonghuming: JSON.parse(localStorage.getItem("userInfo")).NAME,
				/**表单 */
				form: {
					person: ['1', '2'],
					kefuzhanghao: this.$route.query.kefuzhanghao, //账号
					kefumima: this.$route.query.kefumima, //密码
					juese: this.$route.query.juese, //角色
					xiafadaoweijiedan: "Y", //是否下发
					kefuxingming: this.$route.query.kefuxingming,
					xuanzekehu: "",
					yujiwanchengshijian: "", //预计完成时间
					kefugonghao: this.$route.query.kefugonghao,
					xuhaoID: this.$route.query.xuhaoID,
					zhanghaozhuangtai: this.$route.query.zhanghaozhuangtai,

				},

				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				jueseListcopy: [],
				jueseList: [],
				jueseListz: [],
				loading: false, //搜索加载状态
				scoped: false,

				/*表单规则 */
				formRule: {
					kefumima: [{
						required: true,
						message: "请输入",
						// trigger: "blur"
					}],
					kefuzhanghao: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					kefuxingming: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					miaoshu: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					person: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					juese: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					xiafadaoweijiedan: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					yuanchenggongju: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					yujiwanchengshijian: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}]

				},
			};
		},

		mounted() {
			this.checkedCities = this.$route.query.chanpinxian.map(Number);

			this.form.kefuzhanghao = this.$route.query.kefuzhanghao; //账号
			this.form.kefumima = this.$route.query.kefumima; //密码
			this.form.juese = this.$route.query.juese; //角色
			this.form.kefuxingming = this.$route.query.kefuxingming;
			this.form.kefugonghao = this.$route.query.kefugonghao;
			this.form.xuhaoID = this.$route.query.xuhaoID;
			this.form.zhanghaozhuangtai = this.$route.query.zhanghaozhuangtai;

			this.getPerson()
			this.getJueSe()
			// this.$nextTick(() => {
			// 	this.$refs.kefuzhanghao.focus()
			// })

			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				// })()
			}


		},
		activated() {
			this.checkedCities = this.$route.query.chanpinxian.map(Number);

			this.form.kefuzhanghao = this.$route.query.kefuzhanghao; //账号
			this.form.kefumima = this.$route.query.kefumima; //密码
			this.form.juese = this.$route.query.juese; //角色
			this.form.kefuxingming = this.$route.query.kefuxingming;
			this.form.kefugonghao = this.$route.query.kefugonghao;
			this.form.xuhaoID = this.$route.query.xuhaoID;
			this.form.zhanghaozhuangtai = this.$route.query.zhanghaozhuangtai;
			this.getPerson()
			this.getJueSe()
			// this.$nextTick(() => {
			// 	this.$refs.kefuzhanghao.focus()
			// })

			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				// })()
			}
		},

		methods: {
			fanhui() {
				this.$router.go(-1);
			},
			handleCheckAllChange(val) {
				console.log(val)
				if (val == true) {
					var arr = [];
					for (var i in this.staff) {
						arr.push(this.staff[i].Code)
					}
					this.checkedCities = arr
				} else {
					this.checkedCities = [];
				}


				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				console.log(value)
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.staff.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.staff.length;
			},
			dianjichanpinxianyc() {
				this.YuanChengGongJuList = this.YuanChengGongJuListz;
			},
			bindSelectChangeyc(val) {

				if (val) {
					this.YuanChengGongJuList = this.YuanChengGongJuListcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.YuanChengGongJuList = this.YuanChengGongJuListcopy
				}

			},
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.$nextTick(() => {
					this.$refs.juese.focus()
				})
			},


			bindSelectChange(val) {

				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},
			dianjichanpinxianjs() {
				this.jueseList = this.jueseListz;
				this.$nextTick(() => {
					this.$refs.jueseList.focus()
				})
			},


			bindSelectChangejs(val) {

				if (val) {
					this.jueseList = this.jueseListcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.jueseList = this.jueseListcopy
				}

			},
			/**获取产品线 */
			getPerson() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetProducts",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {



							this.staff = res.Data;
							this.staffz = res.Data;
							this.staffcopy = this.staff;


							if (this.staff.length > 0) {
								this.form.person = this.staff[0].Code;
							}

						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**获取角色 */
			getJueSe() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetRoles",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							var arr = [];
							for (var i in res.Data) {
								if (res.Data[i].Code != "12") {
									arr.push(res.Data[i])
								}
							}


							this.jueseList = arr;
							this.jueseListz = arr;
							this.jueseListcopy = this.jueseList;
							for (var j in this.jueseList) {
								if (this.jueseList[j].Code == this.form.juese) {
									this.form.juese = this.jueseList[j].Code
								}
							}


						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**提交选项 */
			submitForm() {


				this.$refs.form.validate((valid) => {
					if (valid) {

						if (this.form.kefuzhanghao.length == 0 || this.form.kefuzhanghao.length > 0 && this.form
							.kefuzhanghao.trim().length == 0) {
							this.$message({
								message: "账号不能为空！",
								type: "error",
							});
						} else if (this.form.kefuxingming.length == 0) {
							this.$message({
								message: "姓名不能为空！",
								type: "error",
							});
						} else {

							if (this.checkedCities.length == 0) {
								this.$message({
									message: "请选择产品线！",
									type: "error",
								});
							} else {

								let chanpinxian = this.checkedCities.join(",");

								let data = {

									ID: this.form.xuhaoID, //序号
									JOB_NUMBER: this.form.kefugonghao, //工号
									COMPANY_NUMBER: "", //单位编号
									ACCOUNT: this.form.kefuzhanghao, //账号
									PASSWORD: this.form.kefumima, //密码
									ROLE: this.form.juese, //角色
									NAME: this.form.kefuxingming, //姓名
									CONTACT_INFORMATION: this.form.kefudianhua, //联系方式
									PRODUCT_LINE: chanpinxian, //产品线
									ACCOUNT_STATUS: this.form.zhanghaozhuangtai, //账号状态

								};
								this.isTiJiao = true;

								this.scoped = true;

								this.$request({
										method: "post",
										url: "ACCOUNT/Edit",
										data: data,
									})
									.then(() => {
										this.isTiJiao=false;
										this.$message({
											message: "修改成功！",
											type: "success",
										});
										this.form.kefuzhanghao = "";
										this.form.juese = this.jueseList[0].Code;
										this.form.kefuxingming = "";
										this.form.kefumima = "";
										this.checkedCities = [];
										this.form.kefudianhua = "";
										// this.$router.push({ path: "weijiekongdan" });
										this.$router.go(-1);
									})
									.catch((err) => {
										this.isTiJiao=false;
										if (err == "Error: Request failed with status code 401") {
											this.$router.push({
												path: "/login",
											});
										}
									});
							}

						}
					}
				});
			},
			/**重置表单 */
			resetForm() {
				this.$refs.form.resetFields();
			},
			//回车事件
			xzkefumima() {
				this.$nextTick(() => {
					this.$refs.kefumima.focus()
				})
			},

			xzkefuxingming() {
				this.$nextTick(() => {
					this.$refs.kefuxingming.focus()
				})
			},
			xzkefudianhua() {
				this.$nextTick(() => {
					this.$refs.kefudianhua.focus()
				})
			},
			xzchanpinxian() {
				this.$nextTick(() => {
					this.$refs.chanpinxian.focus()
				})
			},




		},
	};
</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		background-color: #F0F0F0;
	}

	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.header {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headera {
		margin-bottom: 2px;
	}



	.fanhuiBtn {
		margin-top: 10px;
		margin-left: 20px;
		margin-bottom: 20px;
		display: inline-block;
	}

	.el-input {
		width: 100px;
	}

	.yonghuminglabe {
		margin-top: 30px;
		margin-left: 30px;
		margin-bottom: 0px;
		display: inline-block;
	}

	/* 主体容器 */
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
	}

	.tijiaobtn {
		margin-left: 50%;
		margin-top: 10px;
		width: 100px;
		margin-bottom: 20px;
	}

	.header-con {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 30px;
	}

	.header-cona {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	/**输入框宽度 */
	.form-item-input {
		width: 400px;
	}

	/**输入框后面的备注 */
	.form-item-tip {
		display: inline-block;
		margin-left: 10px;
		color: #606266;
		font-size: 14px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.shangchuantupian {
		margin-left: 80px;
		margin-bottom: 20px;
		width: 80%;



	}

	/* 主体容器 */
	.maina {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 10px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	/* 主体容器 */
	.mainxjgda {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 0px;
		margin-top: 20px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	.shangchuantupianx {
		margin-left: 10px;
		margin-top: 10px;

		display: inline-block;
	}

	.medium {
		width: 400px;
		height: 30px;
		text-align: left;
		color: #999999;
		font-weight: 400;
	}

	.mediuma {
		width: 400px;
		height: 30px;
		text-align: left;
		color: #333333;
		font-weight: 400;
	}

	/**输入框宽度 */
	.form-item-inputcpx {
		width: 400px;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}

	.fankuiImage {
		width: 100%;
		height: 100%;



	}
	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
